const Constants = {
    GRAVITY: 9.81,
};
const CollisionFlags = {
    STATIC: 1,
    KINEMATIC: 2,
    NO_CONTACT_RESPONSE: 4,
    CUSTOM_MATERIAL: 8,
    CHARACTER_OBJECT: 16,
};
const CharacterConfig = {
    COLLISION_FILTER_GROUP: 32,
    COLLISION_FILTER_MASK: 3,
    STEP_HEIGHT: 0.35,
    UP_AXIS: 1,
    ACTIVATION_STATE: 4,
    COLLISION_FLAGS: CollisionFlags.CHARACTER_OBJECT,
};
const ImmovableBodyConfig = {
    MASS: 0,
    RESTITUTION: 0,
    FRICTION: undefined,
    ROLLING_FRICTION: undefined,
    ACTIVATION_STATE: 4,
    COLLISION_FLAGS: CollisionFlags.STATIC,
};
export { Constants, CharacterConfig, ImmovableBodyConfig };
